import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { EventService } from 'src/app/services/events/event.service';
import { UiService } from 'src/app/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';

@Component({
  selector: 'app-add-voucher',
  templateUrl: './add-voucher.component.html',
  styleUrls: ['./add-voucher.component.scss'],
})
export class AddVoucherComponent implements OnInit {
  public voucherCode: string;
  public error: string;
  public submittedSuccess: boolean;
  constructor(
    private modalController: ModalController,
    private eventService: EventService,
    private uiService: UiService,
    private navControl: NavController,
    private translate: TranslateService,
    private i18Config: I18ConfigService
  ) {}

  ngOnInit() {
    this.voucherCode = '';
    this.error = '';
  }

  closeModal() {
    this.modalController.dismiss();
  }

  submitRequest() {

    const voucher = this.voucherCode;

    this.eventService
      .verifyMembershipVoucher(this.voucherCode)
      .subscribe((response) => {
        if (response?.tierInfo?.currency) {
          this.i18Config.setCurrency(response.tierInfo.currency);
        }
        if (response.status === 1) {
          this.submittedSuccess = true;
          setTimeout(() => {
            this.modalController.dismiss();
            this.navControl.navigateBack(['/home']);
          }, 3000); //3s
        } else if (response.status === 0) {
          this.error = response.message;
        } else {
          this.uiService.presentToast(this.translate.instant('toast_message.something_went_wrong'));
        }
      });
  }
}
